/**
 * Ensures an async function displays a loading state for at least MIN_LOADING_DURATION.
 *
 * @param fn - The async function to run.
 * @param setLoading - React state setter for the loading flag.
 * @param minimumDuration - Optional override (default 500ms).
 */
export async function minimumLoading(
  fn: () => Promise<void>,
  setLoading: (value: boolean) => void,
  minimumDuration = 500,
): Promise<void> {
  setLoading(true);

  const start = Date.now();

  try {
    await fn();
  } finally {
    const elapsed = Date.now() - start;
    const remaining = Math.max(0, minimumDuration - elapsed);

    setTimeout(() => {
      setLoading(false);
    }, remaining);
  }
}
